'use client';

import React from 'react';

import useIsOnscreen from '@/hooks/use-is-onscreen';

interface Props extends React.HTMLAttributes<HTMLElement> {
  height: number;
  as?: React.ElementType;
  keepOnceShown?: boolean;
  children: React.ReactNode;
}

const RenderWhenOnscreen = ({
  height,
  children,
  as = 'div',
  keepOnceShown,
  style = {},
}: Props) => {
  const ref = React.useRef(null);
  const [hasBeenShown, setHasBeenShown] = React.useState(false);

  const isOnscreen = useIsOnscreen(ref);

  const hasBeenShownRef =
    React.useRef<typeof hasBeenShown>(hasBeenShown);
  hasBeenShownRef.current = hasBeenShown;

  React.useEffect(() => {
    if (!hasBeenShownRef.current && isOnscreen) {
      setHasBeenShown(true);
    }
  }, [isOnscreen]);

  const shouldRender = keepOnceShown
    ? isOnscreen || hasBeenShown
    : isOnscreen;

  return React.createElement(
    as,
    {
      ref,
      style: { minHeight: height, ...style },
    },
    shouldRender ? children : null
  );
};

export default RenderWhenOnscreen;
